import { FEEDBACK_QUESTION_IDS } from "./types";

export const FEEDBACK_QUESTION_LABELS = {
  [FEEDBACK_QUESTION_IDS.MUSCLE_TARGETED]:
    "QUANTO HAI SENTITO I MUSCOLI BERSAGLIO?",
  [FEEDBACK_QUESTION_IDS.MUSCLE_SORENESS]:
    "QUANTO INDOLENZIMENTO MUSCOLARE HAI AVUTO?",
  [FEEDBACK_QUESTION_IDS.PHYSICAL_TIREDNESS]:
    "COME TI SENTI A LIVELLO DI STANCHEZZA FISICA?",
  [FEEDBACK_QUESTION_IDS.EXERCISE_WEIGHT]: "COME SONO STATI I CARICHI?",
  [FEEDBACK_QUESTION_IDS.DIET_QUANTITY]:
    "A LIVELLO ALIMENTARE COME TI SEI SENTITO?",
  [FEEDBACK_QUESTION_IDS.DIET_QUALITY]: "SEI RIUSCITO A SEGUIRE LA DIETA?",
  [FEEDBACK_QUESTION_IDS.GENERAL_ENERGY]: "Energia generale",
  [FEEDBACK_QUESTION_IDS.SLEEP_QUALITY]: "Qualità del sonno",
  [FEEDBACK_QUESTION_IDS.JOINT_MUSCLE_PAIN]: "Dolori articolari o muscolari",
  [FEEDBACK_QUESTION_IDS.WORKOUT_PERFORMANCE]: "Performance in allenamento",
  [FEEDBACK_QUESTION_IDS.TRAINING_MOTIVATION]: "Motivazione ad allenarti",
  [FEEDBACK_QUESTION_IDS.RESTING_HEART_RATE]:
    "Frequenza cardiaca a riposo (bpm)",
  [FEEDBACK_QUESTION_IDS.HEART_RATE_VARIABILITY]:
    "Variabilità della frequenza cardiaca (HRV)",
  [FEEDBACK_QUESTION_IDS.DIET_ADHERENCE]: "Aderenza alla dieta",
} as const;

export const FEEDBACK_QUESTION_OPTIONS = {
  [FEEDBACK_QUESTION_IDS.MUSCLE_TARGETED]: [
    "Molto bruciore",
    "Un po' di bruciore",
    "Bruciore lieve",
  ],
  [FEEDBACK_QUESTION_IDS.MUSCLE_SORENESS]: [
    "Molto indolenzito, difficoltà ad allenarmi",
    "Abbastanza indolenzito, anche nei giorni successivi",
    "Indolenzito ma non troppo",
  ],
  [FEEDBACK_QUESTION_IDS.PHYSICAL_TIREDNESS]: [
    "Devastato dagli allenamenti",
    "Stanco ma non troppo",
    "Poco stanco, pronto a dare il massimo",
  ],
  [FEEDBACK_QUESTION_IDS.EXERCISE_WEIGHT]: [
    "Male, in calo evidente come reps o kg",
    "Normale, stessi kg e reps",
    "Ottimo, sono riuscito ad aumentare i carichi",
  ],
  [FEEDBACK_QUESTION_IDS.DIET_QUANTITY]: [
    "Troppo cibo",
    "Bene, quantità giusta",
    "Sento spesso fame",
  ],
  [FEEDBACK_QUESTION_IDS.DIET_QUALITY]: [
    "Male, ho seguito poco la dieta",
    "Abbastanza, a parte il weekend",
    "Ottimo, tutti i giorni senza sgarri",
  ],
  [FEEDBACK_QUESTION_IDS.GENERAL_ENERGY]: [
    "Stanchezza costante",
    "Qualche giorno di stanchezza",
    "Energico ogni giorno",
  ],
  [FEEDBACK_QUESTION_IDS.SLEEP_QUALITY]: [
    "Scarsa (<6h)",
    "Discreta (6−7h)",
    "Ottima (≥7,5h)",
  ],
  [FEEDBACK_QUESTION_IDS.JOINT_MUSCLE_PAIN]: [
    "Dolore limitante",
    "Fastidio leggero",
    "Nessun fastidio",
  ],
  [FEEDBACK_QUESTION_IDS.WORKOUT_PERFORMANCE]: [
    "Peggiorata",
    "Stabile",
    "Migliorata",
  ],
  [FEEDBACK_QUESTION_IDS.TRAINING_MOTIVATION]: [
    "Bassa/assente",
    "Neutra",
    "Alta",
  ],
  [FEEDBACK_QUESTION_IDS.RESTING_HEART_RATE]: [
    ">+5 bpm sopra media",
    "+3-5 bpm sopra media",
    "Uguale o ≤+2 sopra media",
  ],
  [FEEDBACK_QUESTION_IDS.HEART_RATE_VARIABILITY]: [
    "Molto inferiore (>15%)",
    "Leggermente inferiore (5-10%)",
    "Uguale o > media",
  ],
  [FEEDBACK_QUESTION_IDS.DIET_ADHERENCE]: [
    "No, spesso ho sgarrato",
    "Sì, a parte il weekend",
    "Sì, sempre",
  ],
} as const;
